<template v-if="href">
  <a-link-v2
    :url="href"
    :class="[name, `${name}__link`, { over: active }]"
    @mouseover.native="onCardHover(true)"
    @mouseleave.native="onCardHover(false)"
  >
    <grid
      :class="[`${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
          autoFlow: 'dense',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__thumbnail`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 13, width: 12 },
        ]"
      >
        <a-image-v2
          v-if="(cms.image || {}).filename"
          :src="(cms.image || {}).filename"
          :alt="(cms.image || {}).alt"
          :layout="[
            { size: 0, bound: 280, ratio: [280, 280] },
            { size: 1, bound: 589, ratio: [589, 589] },
            { size: 2, bound: 589, ratio: [589, 589] },
            { size: 3, bound: 589, ratio: [589, 589] },
          ]"
          :class="`${name}__image`"
        />
        <a-svg-dots :class="`${name}__pattern`" />
      </grid-item>
      <grid-item
        :class="[`${name}__grid-item`, `${name}__content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 3, x: 1, width: 12 },
        ]"
      >
        <a-eyebrow v-if="cms.eyebrow" :cms="cms" :class="`${name}__eyebrow`" />
        <a-heading v-if="cms.heading" :cms="cms" :class="`${name}__heading`" />
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="cms.copy"
          :class="`${name}__text`"
          v-html="$options.filters.markdown(cms.copy)"
        />
        <!--eslint-enable-->
        <component
          :is="item.component"
          v-for="item in cms.cta"
          :key="item._uid"
          v-editable="item"
          html-tag="span"
          :cms="item"
          type="secondary"
          :class="`${name}__cta`"
        />
      </grid-item>
    </grid>
  </a-link-v2>
</template>

<script>
import Href from '@/mixins/href'
import data from '~/components/molecules/m-cards/m-card-feature.data'
import ASvgDots from '~/components/atoms/a-svgs/a-svg-dots'
import ACtaV2 from '~/components/atoms/a-ctas/a-cta-v2'

export default {
  components: { ASvgDots, ACtaV2 },
  mixins: [Href],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
    url: {
      type: String,
      default() {
        return null
      },
    },
  },
  data() {
    return {
      name: 'm-card-feature',
      active: false,
    }
  },
  methods: {
    onCardHover(boolean) {
      this.active = boolean || false
    },
  },
}
</script>

<style lang="scss">
.m-card-feature {
  &__pattern picture,
  &__pattern img {
    width: auto;
  }
}
</style>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-card-feature {
  // border-top: solid 1px;
  // padding: 30px 0 45px;

  ::v-deep p,
  ::v-deep img,
  ::v-deep a,
  ::v-deep .a-cta {
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
      border 0.2s ease-in-out, 0.8s filter ease-in-out, opacity 0.2s ease-in-out;
  }

  &:hover {
    ::v-deep p {
      color: var(--text-color);
    }
    ::v-deep a,
    ::v-deep .a-cta {
      color: var(--hover-color);
    }
  }

  &__thumbnail {
    position: relative;
    padding: 0 0 50px 50px;
    margin-bottom: 30px;
  }

  &__image {
    position: relative;
    z-index: 1;
  }

  &__pattern {
    position: absolute;
    bottom: -10px;
    left: -10px;
  }

  &__heading {
    @include font-family($headings-font-family, 600);
    @include font-size(36, 40.8px);

    margin: 0 0 40px;
    letter-spacing: 1px;
  }

  &__text {
    @include font-size(18, 25.2px);

    margin-bottom: 40px;
    letter-spacing: 1px;
  }
}

@include media-breakpoint-up(md) {
  .m-card-feature {
    margin-top: 30px;

    &__thumbnail {
      margin-bottom: 0;
    }

    &__heading {
      @include font-family($headings-font-family, 600);
      @include font-size(46, 55.2px);
    }
  }
}

@include media-breakpoint-up(lg) {
  .m-card-feature {
    &__heading {
      @include font-family($headings-font-family, 600);
      @include font-size(65, 78px);
    }
  }
}

@include media-breakpoint-up(xl) {
  .m-card-feature {
    &__heading {
      @include font-family($headings-font-family, 600);
      @include font-size(83, 96px);
    }
  }
}
</style>
